import { render, staticRenderFns } from "./EpiscopePlaceholder.vue?vue&type=template&id=44b34660&"
import script from "./EpiscopePlaceholder.vue?vue&type=script&lang=js&"
export * from "./EpiscopePlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports